import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseIcon from "@mui/icons-material/Close";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import DiamondIcon from "@mui/icons-material/Diamond";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import FactoryIcon from "@mui/icons-material/Factory";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import HourglassTopOutlinedIcon from "@mui/icons-material/HourglassTopOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import LowPriorityOutlinedIcon from "@mui/icons-material/LowPriorityOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ModeStandbyIcon from "@mui/icons-material/ModeStandby";
import MoveToInboxOutlinedIcon from "@mui/icons-material/MoveToInboxOutlined";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import PieChartOutlinedIcon from "@mui/icons-material/PieChartOutlined";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReportGmailerrorredOutlinedIcon from "@mui/icons-material/ReportGmailerrorredOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import StorefrontIcon from "@mui/icons-material/Storefront";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";

export const statusBadgeConfig = {
  PENDING: {
    label: "pending",
    color: "#D97706",
    background: "#FFFBEB",
    icon: <WatchLaterOutlinedIcon />,
  },
  SUCCESS: {
    label: "success",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <CheckOutlinedIcon />,
  },
  FAILED: {
    label: "failed",
    color: "#B42318",
    background: "#FEF3F2",
    icon: <CloseIcon />,
  },
  APPROVED: {
    label: "approved",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <CheckOutlinedIcon />,
  },
  REJECTED: {
    label: "rejected",
    color: "#B42318",
    background: "#FEF3F2",
    icon: <CloseIcon />,
  },
  COMPLETED: {
    label: "completed",
    color: "#055160",
    background: "#e3f6fa",
    icon: <TaskAltIcon />,
  },
  DEPOSIT: {
    label: "deposit",
    color: "#7c7c7c",
    background: "#F3F3F3",
    icon: <AssuredWorkloadIcon />,
  },
  WITHDRAWAL: {
    label: "withdrawal",
    color: "#a7784d",
    background: "#FDEDE4",
    icon: <CreditScoreIcon />,
  },
  PAYMENT: {
    label: "payment",
    color: "#ab8a21",
    background: "#FAF3DC",
    icon: <ReceiptIcon />,
  },
  PURCHASE: {
    label: "purchase",
    color: "#1E40AF",
    background: "#e8f2fe",
    icon: <ShoppingCartIcon />,
  },
  SALE: {
    label: "sale",
    color: "#9A3412",
    background: "#fff3e8",
    icon: <StorefrontIcon />,
  },
  METAL: {
    label: "metal",
    color: "#a58144",
    background: "#FAF3E0",
    icon: <EmojiEventsIcon />,
  },
  STONE: {
    label: "stone",
    color: "#505dce",
    background: "#eaefff",
    icon: <DiamondIcon />,
  },
  INVESTOR: {
    label: "INVESTOR",
    color: "#b6973e",
    background: "#faf4dd",
    icon: <BusinessCenterIcon />,
  },
  SAVER: {
    label: "SAVER",
    color: "#b6973e",
    background: "#faf4dd",
    icon: <BusinessCenterIcon />,
  },
  SELLER: {
    label: "SELLER",
    color: "#c18169",
    background: "#fcf0eb",
    icon: <FactoryIcon />,
  },
  JEWELER: {
    label: "DESIGNER",
    color: "#6c92af",
    background: "#eef3f8",
    icon: <DiamondIcon />,
  },
  MANUFACTURER: {
    label: "MANUFACTURER",
    color: "#4aa88a",
    background: "#eaf7f3",
    icon: <PrecisionManufacturingIcon />,
  },
  SUSPENDED: {
    label: "suspended",
    color: "#B42318",
    background: "#FEF3F2",
    icon: <NotInterestedIcon />,
  },
  ACTIVATED: {
    label: "activated",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <VerifiedOutlinedIcon />,
  },
  ENABLED: {
    label: "enabled",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <PowerSettingsNewIcon />,
  },
  DISABLED: {
    label: "disabled",
    color: "#B42318",
    background: "#FEF3F2",
    icon: <NotInterestedIcon />,
  },
  DELETED: {
    label: "deleted",
    color: "#B42318",
    background: "#FEF3F2",
    icon: <DeleteOutlinedIcon />,
  },
  OPEN: {
    label: "open",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <ModeStandbyIcon />,
  },
  CLOSED: {
    label: "closed",
    color: "#B42318",
    background: "#FEF3F2",
    icon: <HighlightOffOutlinedIcon />,
  },
  HIGH: {
    label: "high",
    color: "#B42318",
    background: "#FEF3F2",
    icon: <ReportGmailerrorredOutlinedIcon />,
  },
  MEDIUM: {
    label: "medium",
    color: "#D97706",
    background: "#FFFBEB",
    icon: <ReportProblemOutlinedIcon />,
  },
  LOW: {
    label: "low",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <LowPriorityOutlinedIcon />,
  },
  PENDING_FOR_RENEWAL: {
    label: "pending-for-renewal",
    color: "#D97706",
    background: "#FFFBEB",
    icon: <WatchLaterOutlinedIcon />,
  },
  TERMINATED: {
    label: "terminated",
    color: "#6B7280",
    background: "#E5E7EB",
    icon: <NotInterestedIcon />,
  },
  QUOTATION_SUBMITTED: {
    label: "quotation-submitted",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <VerifiedOutlinedIcon />,
  },
  ACCEPTED: {
    label: "accepted",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <CheckOutlinedIcon />,
  },
  PAYMENT_PENDING: {
    label: "payment-pending",
    color: "#D97706",
    background: "#FFFBEB",
    icon: <WatchLaterOutlinedIcon />,
  },
  ACTIVE: {
    label: "active",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <CheckOutlinedIcon />,
  },
  TRIALING: {
    label: "trialing",
    color: "#1E40AF",
    background: "#EFF6FF",
    icon: <HourglassTopOutlinedIcon />,
  },
  CANCELLED: {
    label: "cancelled",
    color: "#B42318",
    background: "#FEF3F2",
    icon: <CloseIcon />,
  },
  EXPIRED: {
    label: "expired",
    color: "#6B7280",
    background: "#F3F4F6",
    icon: <AccessTimeOutlinedIcon />,
  },
  APPROVED_BY_JEWELER: {
    label: "approved-by-jeweler",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <CheckOutlinedIcon />,
  },
  WAITING_FOR_JEWELER: {
    label: "waiting-for-jeweler",
    color: "#D97706",
    background: "#FFFBEB",
    icon: <WatchLaterOutlinedIcon />,
  },
  UNDER_INSPECT: {
    label: "under-inspect",
    color: "#0E5EBD",
    background: "#E0F2FE",
    icon: <SearchOutlinedIcon />,
  },
  IN_MANUFACTURING: {
    label: "in-manufacturing",
    color: "#9333EA",
    background: "#F3E8FF",
    icon: <PrecisionManufacturingOutlinedIcon />,
  },
  OUT_FOR_DELIVERY: {
    label: "out-for-delivery",
    color: "#1D4ED8",
    background: "#DBEAFE",
    icon: <LocalShippingOutlinedIcon />,
  },
  IN_PROGRESS: {
    label: "in-progress",
    color: "#1976D2",
    background: "#E3F2FD",
    icon: <HourglassTopOutlinedIcon />,
  },
  DELIVERED: {
    label: "delivered",
    color: "#065F46",
    background: "#D1FAE5",
    icon: <MoveToInboxOutlinedIcon />,
  },
  DRAFT: {
    label: "draft",
    color: "#6B7280",
    background: "#F3F4F6",
    icon: <ManageAccountsIcon />,
  },
  VERIFICATION_PENDING: {
    label: "verification-pending",
    color: "#B45309",
    background: "#FFFBEB",
    icon: <WatchLaterOutlinedIcon />,
  },
  NOT_SUBSCRIBED: {
    label: "not-subscribed",
    color: "#B45309",
    background: "#FFF7ED",
    icon: <HourglassEmptyOutlinedIcon />,
  },
  ADMIN_APPROVED: {
    label: "admin-approval",
    color: "#027A48",
    background: "#ECFDF3",
    icon: <CheckOutlinedIcon />,
  },
  PAYMENT_REQUESTED: {
    label: "payment-requested",
    color: "#6B21A8",
    background: "#EDE9FE",
    icon: <HourglassEmptyOutlinedIcon />,
  },
  UNDER_TERMINATION: {
    label: "under-termination",
    color: "#1D4ED8",
    background: "#DBEAFE",
    icon: <WatchLaterOutlinedIcon />,
  },
  JEWELRY_DESIGN: {
    label: "jewelry-design",
    color: "#6D28D9", // royal purple (creative / luxury)
    background: "#f3e8ff", // soft lavender
    icon: <DiamondOutlinedIcon />, // spark/design icon
  },
  PENDING_SELLER_PRICE: {
    label: "pending-seller-price",
    icon: <PendingActionsOutlinedIcon />,
    color: "#854D0E",
    background: "#fef7e8",
  },
  PENDING_INVESTOR_CONFIRMATION: {
    label: "pending-saver-approval",
    color: "#1E3A8A",
    background: "#eef3ff",
    icon: <HourglassEmptyOutlinedIcon />,
  },
  PROFIT_DISTRIBUTION: {
    label: "profit-distribution",
    color: "#1E3A8A",
    background: "#eef3ff",
    icon: <PieChartOutlinedIcon />,
  },
};
